import LayoutNode, { setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { SiteData } from "../Data/SiteData";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import { Fragment } from "react";
import { ColorRatioPair, GetADACombinations } from "./ColorPalleteMenu";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";




export function OpenComponentColorPaletteMenu(siteData:SiteData,node:LayoutNode){






            
        const dom = document.getElementById("OpenDialog");
        const PopupClose = () => {
           
            if (dom) unmountComponentAtNode(dom);
            siteData.designer?.forceUpdate();
           
        };
        

   
        ReactDOM.render(
            <>
            <VGPopUp
              id={"c-palette-popup"}
              show={true}
              onHide={PopupClose}
              title="Select a Color Combination"
              dialogClassName="block-edit"
              body={
                <div className="alertContent">
                    <ComponentPaletteOptions siteData={siteData} onSelect={(combo:ColorRatioPair)=>{
                        
                        const aIndex = siteData.siteStyling.colorPallet.indexOf(combo.colorA)+1;
                        const bIndex = siteData.siteStyling.colorPallet.indexOf(combo.colorB)+1;

                        setNodeStyleAttributeValue(node,ScreenSize.Desktop,"color","var(--theme-color-"+aIndex+")");
                        setNodeStyleAttributeValue(node,ScreenSize.Desktop,"backgroundColor","var(--theme-color-"+bIndex+")");
                        PopupClose();
                        siteData?.designer?.saveUndoState(true);


                    } }/>
                </div>
              }
              footer={
                <Fragment>
                 
                <button className="w-button w-button-secondary" onClick={(e) => { PopupClose();}}>Cancel</button>
                </Fragment >
              }
              isRemoveTabModalIndex={false}
              isShowFooter={true}
              size={"modal-md"}
              backdrop={true}
            />
      
            </>,
            dom);

  





}



function ComponentPaletteOptions({siteData,onSelect}:{siteData:SiteData,onSelect:Function}){


    const combos = GetADACombinations(siteData).compliant;

    const allCombos = [];
    for(let i = 0;i<combos.length;i++){
        const combo = combos[i];
        allCombos.push(combo);
        allCombos.push({ratio:combo.ratio,colorA:combo.colorB,colorB:combo.colorA,labelA:combo.labelB,labelB:combo.labelA});
    }

    allCombos.sort((a:any,b:any)=>{
        return a.colorA.localeCompare(b.colorA);
    })

    return <div className="flex-row flex-wrap">
        {
            allCombos.length==0?<div>No valid color combinations found</div>:null
        }

        {
            allCombos.map((combo,index)=>{
                return <div  key={index} style={{padding:"4px",width:"25%",height:"85px"}}>
                
                <button className="invisible-button w-full h-full"
                    onClick={()=>{
                        onSelect(combo);
                    }}
                    style={{background:combo.colorB,color:combo.colorA,borderRadius:"8px",padding:"8px 0px",border:"1px solid #ccc"}}
                >
                    <div className="font-small">
                        <div className=" font-bold" >{combo.labelA}</div>
                        <div style={{width:"80%",margin:"2px 10%",background:combo.colorA,height:"1px",opacity:".5"}}></div>
                        <div className=" font-bold">{combo.labelB}</div>
                    </div>
                </button>
                </div>

            } )
        }

        </div>



 }